import { MarkdownPanelSpec, markdownPanelSpecSchema } from '@/core';
import { createVisualization } from '../../../plugin-system';
import { MarkdownIcon } from './MarkdownIcon';
import { MarkdownPanel } from './MarkdownPanel';
import { MarkdownPanelOptionsEditor } from './MarkdownPanelOptionsEditor';
import { createInitialMarkdownPanelSpec } from './markdown-panel-model';

export const Markdown = createVisualization(MarkdownPanel, {
  dashboardConfig: {
    kind: 'Markdown',
    mapSpecToProps: (spec: MarkdownPanelSpec) => spec,
    mapPropsToSpec: (props) => props,
    panelOptionsEditorComponents: [
      {
        label: 'Markdown',
        content: MarkdownPanelOptionsEditor,
      },
    ],
    createInitialOptions: createInitialMarkdownPanelSpec,
    hideQueryEditor: true,
    schema: markdownPanelSpecSchema,
    icon: MarkdownIcon,
  },
});

export type MarkdownVizProps = React.ComponentProps<typeof Markdown.Viz>;
export type MarkdownVizBaseProps = React.ComponentProps<typeof Markdown.VizBase>;
